// src/utils/layout/layoutHelpers.js
//
// Outlier mesh filtreleme ve visible-only bbox hesaplama.

import * as THREE from 'three';

export function hideOutlierMeshes(root, planSize, label) {
  if (!root || !root.traverse) return 0;
  const threshold = planSize > 0 ? planSize * 1.5 : Infinity;
  const sizeCheck = Number.isFinite(threshold);
  let hiddenCount = 0;
  root.traverse((c) => {
    if (!c.geometry) return;
    const posAttr = c.geometry.getAttribute?.('position');
    if (!posAttr || posAttr.count === 0) return;
    if (c.visible === false) return;
    let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    let hasNaN = false;
    for (let i = 0; i < posAttr.count; i++) {
      const x = posAttr.getX(i), y = posAttr.getY(i);
      if (!Number.isFinite(x) || !Number.isFinite(y)) { hasNaN = true; continue; }
      if (sizeCheck) {
        if (x < minX) minX = x; if (x > maxX) maxX = x;
        if (y < minY) minY = y; if (y > maxY) maxY = y;
      }
    }
    let outBySize = false;
    if (sizeCheck && minX !== Infinity) {
      if ((maxX - minX) > threshold || (maxY - minY) > threshold) outBySize = true;
    }
    if (hasNaN || outBySize) { c.visible = false; hiddenCount++; }
  });
  return hiddenCount;
}

export function computeVisibleBoundingBox(object) {
  const box = new THREE.Box3();
  object.updateMatrixWorld(true);
  object.traverse((child) => {
    if (!child.visible || !child.geometry) return;
    if (child.geometry.boundingBox === null) child.geometry.computeBoundingBox();
    const cb = child.geometry.boundingBox;
    if (!cb) return;
    if (!Number.isFinite(cb.min.x) || !Number.isFinite(cb.max.x) ||
        !Number.isFinite(cb.min.y) || !Number.isFinite(cb.max.y)) return;
    const childBox = new THREE.Box3().copy(cb).applyMatrix4(child.matrixWorld);
    if (!Number.isFinite(childBox.min.x) || !Number.isFinite(childBox.max.x)) return;
    box.union(childBox);
  });
  if (box.isEmpty()) box.setFromObject(object);
  return box;
}
